import React from 'react';

import PropTypes from 'prop-types';

import { DASHBOARD_ITEM_API_NAMES } from '@src/constants/commons';

import { chartProptype, filtersProptype } from '../../../../../utils/proptypes/charts';
import DashboardWidget from '../DashboardWidget';
import { chartConfig, scheduleComplianceHistChartConfig } from '../DashboardWidget/configs';

const ChartCard = ({ chart, onEdit, refresh, filters }) => {
  const configs = {
    [DASHBOARD_ITEM_API_NAMES.NUMBER_METRICS_DASHBOARD]: chartConfig,
    [DASHBOARD_ITEM_API_NAMES.SCHEDULES_COMPLIANCE_HIST]: scheduleComplianceHistChartConfig,
  };
  return (
    <DashboardWidget
      widget={chart}
      onEdit={onEdit}
      refresh={refresh}
      filters={filters}
      config={configs[chart.apiName] || chartConfig}
    />
  );
};

ChartCard.propTypes = {
  chart: chartProptype.isRequired,
  onEdit: PropTypes.func.isRequired,
  refresh: PropTypes.bool.isRequired,
  filters: filtersProptype.isRequired,
};

export default ChartCard;
